/** @type {import('./index').NetworkConfig} */
const youtube = {
  name: 'YouTube',
  sort: 3,
  // Modern canonical profile URL is /@handle; getProfileUrl strips a leading '@'
  // on the handle first, so this won't double up (matches TikTok's baseUrl).
  baseUrl: 'https://www.youtube.com/@',
  domains: ['youtube.com', 'youtu.be'],
  supported: true,
  color: '#FF0000',
  hasVideoContent: true,
  supportsEmbed: true,
  requiresReferrer: false,
  profileUrlPattern: /^https:\/\/(?:www\.)?youtube\.com\/(?:channel\/([a-zA-Z0-9_-]+)|@([a-zA-Z0-9_.]+))\/?$/,
};

export default youtube;
